/**
 *  Används för att hämta fastigheter inom en viss area
 **/
export async function fetchDataWMS(url: string): Promise<any> {
  return fetch(url)
    .then((response) => response.json())
    .catch(() => console.log('Fel i slagning mot WMS. Kontrollera URL:en.'));
}

/**
 *  Används för att hämta fastigheter med tillhörande skift med ett objektid
 **/
export async function fetchDataWFS(url: string): Promise<any> {
  return fetch(url)
    .then((response) => response.json())
    .catch(() => console.log('Fel i slagning mot WMS. Kontrollera URL:en.'));
}

export {};
